<template>
  <div class="order-form">
    <!-- Если открывается из приложение асинхронно подключаем компонент со стилями, подробнее в компоненте -->
    <AppStyles v-if="additional.isApp || base.isAdmin" />
    <!-- -- -->
    <ChooseOrderTypeModal v-if="isShowOrderTypeModal" @onChosen="isShowChooseOrderType = false" />
    <AppHeader v-if="base.isAdmin" />
    <main id="order-main">
      <ModalTransition>
        <MapModal v-if="modals.selectionOnMap" />
        <TemplatesModal v-if="modals.templates" />
        <CouriersModal v-if="modals.favouriteCouriers" />
        <ModalWarning v-if="modals.warningMessage" />
        <CreateDraftModal v-if="modals.createNewTemplate" />
        <OrderCreatedModal v-if="modals.orderCreated" />
        <BindNewCardModal v-if="modals.bindNewCard" />
        <PhoneApproveModal v-if="isAnonimousForm && modals.approvePhone" />
      </ModalTransition>
      <div class="container">
        <div class="main-wrap">
          <section class="main-section">
            <!-- <MessagePool /> -->
            <Spinner style="margin-top: 5rem" v-if="isFormLoading" />
            <div v-else class="create-order-wrap">
              <div class="order-block city" v-if="additional.isApp">
                <CitySelect />
              </div>
              <div class="order-block-transparent">
                <AutoComponent />
              </div>
              <div class="order-block">
                <AdminBlock v-if="base.isAdmin" />
                <DotComponent :dot="order.dots[0]" />
              </div>
              <ExpandTransition>
                <div
                  class="order-block__animation-wrapper"
                  v-for="(dot, index) in order.dots.slice(1)"
                  :key="index"
                >
                  <div class="order-block">
                    <DotComponent :dot="dot" />
                  </div>
                </div>
              </ExpandTransition>
              <div class="order-block-transparent">
                <div v-if="order.dots.length < form.dotsLimit" class="block">
                  <div class="add-address">
                    <button class="add-address-button" @click="createNewDot" type="button">
                      Добавить адрес
                    </button>
                  </div>
                </div>
              </div>
              <OrderDetails />
            </div>
          </section>
          <AsideComponent v-if="isEnoughWidth" />
        </div>
      </div>
      <BottomComponent v-if="!isEnoughWidth" />
    </main>
  </div>
</template>

<script>
import Spinner from '@features/UI/FontAwesomeSpinner.vue'
import grecaptcha from '@mixins/grecaptcha'
import getAsyncComponent from '@helpers/asyncComp'
import mainAppMixin from './mixins/mainApp'

import AutoComponent from './components/AutoComponent.vue'
import DotComponent from './components/DotComponent.vue'
import OrderDetails from './components/OrderDetails.vue'
import AsideComponent from './components/AsideComponent.vue'
import BottomComponent from './components/BottomComponent.vue'
import CitySelect from './components/Aside/CitySelect.vue'

import ModalWarning from './components/Modals/ModalWarning.vue'
import BindNewCardModal from './components/Modals/BindNewCardModal.vue'
import MapModal from './components/Modals/MapModal.vue'
import TemplatesModal from './components/Modals/TemplatesModal.vue'
import CouriersModal from './components/Modals/CouriersModal.vue'
import OrderCreatedModal from './components/Modals/OrderCreatedModal.vue'
import CreateDraftModal from './components/Modals/CreateDraftModal.vue'
import ChooseOrderTypeModal from './components/Modals/ChooseOrderTypeModal.vue'
import PhoneApproveModal from './components/Modals/PhoneApproveModal.vue'

import ModalTransition from './components/Transitions/ModalTransition.vue'
import ExpandTransition from './components/Transitions/ExpandTransition.vue'

export default {
  name: 'Order',

  mixins: [mainAppMixin, grecaptcha],

  components: {
    CitySelect,
    AppHeader: getAsyncComponent(() => import('./components/Header/AppHeader.vue')),
    AutoComponent,
    DotComponent,
    OrderDetails,
    AsideComponent,
    BottomComponent,
    ModalWarning,
    BindNewCardModal,
    TemplatesModal,
    CouriersModal,
    OrderCreatedModal,
    CreateDraftModal,
    ChooseOrderTypeModal,
    PhoneApproveModal,
    MapModal,
    ModalTransition,
    ExpandTransition,
    AdminBlock: getAsyncComponent(() => import('./components/AdminBlock.vue')),
    AppStyles: getAsyncComponent(() => import('./components/AppStyles.vue'), null),
    Spinner,
  },
  data: () => ({
    isShowPromo: false,
    widthListener: null,
  }),
  created() {
    if (this.base.isAdmin) window.getVueApp = () => this

    // Записываем в state функцию для генерации токенов recaptcha
    if (this.isAnonimousForm) this.setTokenGenerator(this.tokenGenerator)
  },
}
</script>

<style scoped lang="scss">
.order-form {
  padding: 0;

  background-color: #f7f7f7;

  .container {
    width: 1160px;
    margin: 0 auto;
    padding: 0;
    @media (max-width: 1200px) {
      width: 960px;
    }
    @media (max-width: 992px) {
      width: 720px;
    }
    @media (max-width: 768px) {
      width: 540px;
    }
    @media (max-width: 575px) {
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
/* stylelint-disable-next-line at-rule-no-unknown */
@use 'sass:meta';
/* stylelint-disable-next-line no-invalid-position-at-import-rule */
@import '@assets/scss/components/tooltips'; // Подключение здесь, потому что тултипы генерируются в body

.order-form {
  /* stylelint-disable-next-line at-rule-no-unknown */
  @include meta.load-css('@assets/orderForm/style'); // Инкапсуляция стилей этой зверины
}
</style>
